import { FeatureToggle } from '@components/common';
import FeatureCheck from '@components/common/FeatureCheck';
import { Main, WithResetTrends } from '@src/pages';
import featureNames from '@utils/featureToggle/constants';
import React from 'react';
import { Route, Routes } from 'react-router-dom';

const Trends = (props) => {
  return (
    <FeatureToggle
      feature={featureNames.MINI_ODP_ACCESS}
      fallback={<FeatureCheck featureName={'ODP'} />}
    >
      <WithResetTrends>
        <Main {...props} />
      </WithResetTrends>
    </FeatureToggle>
  );
};

const OdpRouter = () => {
  return (
    <Routes>
      <Route
        path={`/dashboard/:contextId/explore`}
        element={<Trends />}
      />
    </Routes>
  );
};

export default OdpRouter;
